export const ACTIVE_MAINTENANCE_STATUSES = new Set(['QUEUED', 'RUNNING'])

const DATASET_TRANSLATION_KEYS = {
  azs_amount_turnover: 'maintenanceDatasetAmountTurnover',
  azs_append: 'maintenanceDatasetAppend',
  azs_nafta_cards: 'maintenanceDatasetNaftaCards',
  azs_payments: 'maintenanceDatasetPayments',
  azs_sales: 'maintenanceDatasetSales',
  azs_remain: 'maintenanceDatasetRemain',
  azs_rtank: 'maintenanceDatasetRtank',
  azs_rtrk: 'maintenanceDatasetRtrk',
  azs_service_cash_movements: 'maintenanceDatasetServiceCashMovements',
  azs_sessions: 'maintenanceDatasetSessions',
  receipt_headers: 'maintenanceDatasetReceiptHeaders',
  receipt_lines: 'maintenanceDatasetReceiptLines',
  receipt_payments: 'maintenanceDatasetReceiptPayments',
  tank_observations: 'maintenanceDatasetTankObservations',
  azs_cashform: 'maintenanceDatasetCashform',
  azs_cashform_categories: 'maintenanceDatasetCashformCategories',
  azs_groups: 'maintenanceDatasetGroups',
  azs_operator: 'maintenanceDatasetOperator',
  azs_product: 'maintenanceDatasetProduct',
  azs_barcode: 'maintenanceDatasetBarcode',
  azs_sections: 'maintenanceDatasetSections',
  azs_tank: 'maintenanceDatasetTank',
  azs_trk: 'maintenanceDatasetTrk',
}

export function maintenanceDatasetLabel(tableKey, t) {
  const translationKey = DATASET_TRANSLATION_KEYS[tableKey]
  return translationKey ? t(translationKey) : tableKey
}

export function formatStorageBytes(value) {
  const bytes = Number(value ?? 0)
  if (!Number.isFinite(bytes) || bytes <= 0) return '0 B'
  const units = ['B', 'KB', 'MB', 'GB', 'TB']
  const index = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1)
  const amount = bytes / (1024 ** index)
  const digits = amount >= 100 || index === 0 ? 0 : amount >= 10 ? 1 : 2
  return `${amount.toFixed(digits)} ${units[index]}`
}

export function totalStorageRows(categories = []) {
  return categories.reduce((total, category) => total + Number(category.rowCount ?? 0), 0)
}

export function totalStorageBytes(categories = []) {
  return categories.reduce((total, category) => total + Number(category.estimatedBytes ?? 0), 0)
}

export function operationPercentage(operation) {
  const progress = operation?.progress ?? []
  const planned = progress.reduce((total, item) => total + Number(item.plannedRows ?? 0), 0)
  const deleted = progress.reduce((total, item) => total + Number(item.deletedRows ?? 0), 0)
  if (operation?.status === 'SUCCEEDED') return 100
  return planned > 0 ? Math.min(100, Math.round((deleted / planned) * 100)) : 0
}

export async function collectMaintenanceShifts(loader, stationId, limit = 50) {
  const items = []
  const sessionNumbers = new Set()
  let page = 1
  let hasNext = false

  do {
    const response = await loader(stationId, { page, limit })
    for (const shift of response?.items ?? []) {
      const sessionNumber = String(shift.sessionNumber)
      if (sessionNumbers.has(sessionNumber)) continue
      sessionNumbers.add(sessionNumber)
      items.push(shift)
    }
    const totalPages = Number(response?.totalPages ?? 0)
    hasNext = response?.hasNext === true && page < totalPages
    page += 1
  } while (hasNext)

  return items
}
